import LocationListView from "../views/Locations/LocationListView";

export default [
  {
    path: "/Locations",
    name: "Locations",
    component: LocationListView
  }
]